import { motion } from "framer-motion";
import { Cake, Heart, Gem, Briefcase, Baby, Sparkles, PartyPopper, Flower2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { BotanicalDivider } from "./Botanical";
import { SERVICES } from "../../data/content";

const ICONS = { Cake, Heart, Gem, Briefcase, Baby, Sparkles, PartyPopper, Flower2 };

export const Services = () => (
    <section id="services" data-testid="services-section" className="relative bg-emerald py-28 lg:py-36">
        <div
            className="pointer-events-none absolute inset-0 opacity-[0.05]"
            style={{
                backgroundImage:
                    "radial-gradient(circle at 20% 30%, #C9A227 0.8px, transparent 0.8px), radial-gradient(circle at 80% 70%, #C9A227 0.8px, transparent 0.8px)",
                backgroundSize: "90px 90px",
            }}
        />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading
                dark
                eyebrow="We Specialise In"
                title="Celebrations, Beautifully Composed"
                script="every occasion, elevated"
            />
            <div className="mt-6 flex justify-center">
                <BotanicalDivider />
            </div>

            <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {SERVICES.map((s, i) => {
                    const Icon = ICONS[s.icon];
                    const wide = i === 3;
                    return (
                        <motion.div
                            key={s.title}
                            data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                            initial={{ opacity: 0, y: 34 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                            whileHover={{ y: -8 }}
                            className={`group relative overflow-hidden border border-gold/25 bg-emerald-light/60 p-8 backdrop-blur-sm transition-[border-color,box-shadow] duration-500 ease-elegant hover:border-gold/70 hover:shadow-[0_20px_50px_-15px_rgba(201,162,39,0.35)] ${
                                wide ? "sm:col-span-2" : ""
                            }`}
                        >
                            <div className="absolute right-0 top-0 h-16 w-16 translate-x-8 -translate-y-8 rounded-full bg-gold/10 transition-transform duration-700 ease-elegant group-hover:scale-[3]" />
                            <div className="relative">
                                <div className="flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-emerald">
                                    <Icon size={24} strokeWidth={1.4} />
                                </div>
                                <h3 className="mt-6 font-serif text-xl tracking-wide text-ivory">{s.title}</h3>
                                <div className="mt-3 h-px w-10 bg-gold/50 transition-[width] duration-500 ease-elegant group-hover:w-20" />
                                <p className="mt-4 max-h-0 overflow-hidden text-sm leading-relaxed text-ivory/70 opacity-0 transition-[max-height,opacity] duration-600 ease-elegant group-hover:max-h-32 group-hover:opacity-100 sm:max-h-32 sm:opacity-100 lg:max-h-0 lg:opacity-0">
                                    {s.blurb}
                                </p>
                            </div>
                        </motion.div>
                    );
                })}

                <motion.a
                    href="#contact"
                    data-testid="services-cta-card"
                    initial={{ opacity: 0, y: 34 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.7, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    className="group flex flex-col items-start justify-center gap-4 border border-gold bg-gold p-8 transition-[transform,box-shadow] duration-500 ease-elegant hover:-translate-y-2 hover:shadow-[0_20px_50px_-15px_rgba(201,162,39,0.55)]"
                >
                    <span className="font-script text-3xl text-emerald">Dreaming of something?</span>
                    <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-emerald-deep">
                        Begin Your Story <span className="inline-block transition-transform duration-500 group-hover:translate-x-2">→</span>
                    </span>
                </motion.a>
            </div>
        </div>
    </section>
);
